export default __webpack_public_path__ + "turkish-lire-symbol.png";